import { ChapterBar } from '~/components/events/ChapterBar'
import { EventList } from '~/components/events/EventList'
import { useChapter, useChapterEvents } from '~/lib/adb/chapter'

const MAX_EVENTS = 3

/** Homepage "Upcoming events": the visitor's chapter, next three events. */
export function UpcomingEvents() {
  const { chapter, resolved } = useChapter()
  const { upcoming, failed } = useChapterEvents(chapter.ID, null, resolved)
  return (
    <div>
      <ChapterBar />
      <EventList
        events={upcoming}
        failed={failed}
        chapter={chapter}
        limit={MAX_EVENTS}
      />
    </div>
  )
}
